/**
 * Created by dushyantha on 10/12/16.
 */
'use strict';

(function () {
    angular
        .module('trainingSchedule')
        .component('trainerTraineeDetails', {
            templateUrl: 'training-schedule/components/trainer-trainee-details-component.tpl.html',
            controller: function ($scope,EventManagerService) {
                var vm  =  this;
                vm.removeCrew = function (crew) {
                    
                };
                vm.selectTraineeCrew = function (crew) {
                    crew.isSelected = true
                };
                vm.selectTrainerCrew = function (crew) {
                    crew.isSelected = true
                };
                vm.removeCrew = function (parent, child) {
                    vm.removeCrewFromProgram({'removeDTO':{'parentID':parent,'childId':child}})
                };
                vm.addCrew= function () {
                  vm.addCrewToProgram();
                }
            },
            bindings: {
                trainingSchedule :'<',
                selectedRecord:'=',
                selectedCrew:'=',
                removeCrewFromProgram:'&',
                addCrewToProgram:'&'
            }
        });
})();